import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'scrollAnimation',
    label: 'Scroll Animation',
    type: types.BOOLEAN,
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT
  },
  {
    key: 'left_col',
    label: 'Left Column',
    type: types.OBJECT,
    children: [
      {
        key: 'header',
        label: 'Header',
        type: types.TEXT
      },
      {
        key: 'image',
        label: 'Image (Left blank for single-column layout)',
        type: types.TEXT
      },
      {
        key: 'text',
        label: 'Text',
        type: types.RICHTEXT
      }
    ]
  },
  {
    key: 'enable_right_col',
    label: 'Enable Right Column (Uncheck for single column layout)',
    type: types.BOOLEAN
  },
  {
    key: 'right_col',
    label: 'Right Column',
    type: types.OBJECT,
    children: [
      {
        key: 'header',
        label: 'Header',
        type: types.TEXT
      },
      {
        key: 'image',
        label: 'Image (Left blank for single-column layout)',
        type: types.TEXT
      },
      {
        key: 'text',
        label: 'Text',
        type: types.RICHTEXT
      }
    ]
  }
];

const defaultProps = {
  scrollAnimation: true,
  title: 'Downloads',
  left_col: {
    header: 'Our Logo',
    image: 'https://genesis-cdn.ff.com/press_room/news%20logos/logo_black.svg',
    text: `
      <p>800.228.7702</p>
      <p>product@faradayfuture.com</p>
    `
  },
  enable_right_col: true,
  right_col: {
    header: 'About Faraday Future',
    image: '',
    text: `
      <p>Faraday Future is a user-centric, advanced mobility company with
       headquarters in Southern California. Our global team leverages the 
       talents of leading thinkers and passionate creators from the technology 
       and automotive industries to bring premium, intuitive, and seamlessly 
       connected electric vehicles to people worldwide.</p>
      <a>FACT SHEET</a>
    `
  }
};

export default {
  title: 'Assets Download',
  id: 'AssetsDownload',
  propsSchema,
  defaultProps
};


